import { HYDRATE } from 'next-redux-wrapper';

import { SET_ROUTERS } from '../actionTypes/routers';

export default (state = [], action) => {

    const { type, payload } = action;

    switch (type) {
        case HYDRATE:
            return [...payload.routers];
        case SET_ROUTERS:
            return [...payload];
        default:
            return state;
    }
};
